import React from 'react';
import Otros from '../../features/cuestionarios/ViewOtros';
import CuestionarioIncontinencia from '../../features/cuestionarios/sp/CuestionarioIncontinencia';
import CuestionarioVent from '../../features/cuestionarios/vent/CuestionarioVent';
import MainCuestionarioSP from '../../features/cuestionarios/sp/MainCuestionarioSP';
import MainCuestionarioVent from '../../features/cuestionarios/vent/MainCuestionarioVent';
import CuestionarioTesisTorres from '../../features/cuestionarios/tesisTorres/CuestionarioTesisTorres';
import MainCuestionarioTesisTorres from '../../features/cuestionarios/tesisTorres/MainCuestionarioTesisTorres';
import ListCuestionarioTesisTorres from '../../features/cuestionarios/tesisTorres/ListCuestionarioTesisTorres';
import ListCuestionarioVent from '../../features/cuestionarios/vent/ListCuestionarioVent';
import ListCuestionarioSP from '../../features/cuestionarios/sp/ListCuestionarioSP';
import ListOtros from '../../features/cuestionarios/ListOtros';
import MainOtros from '../../features/cuestionarios/MainOtros';
import CreateAntropometriaPage from '../../features/antropometria/pages/CreateAntropometriaPage';
import AntropometriaDetailPage from '../../features/antropometria/pages/AntropometriaDetailPage';
import AntropometriaListPage from '../../features/antropometria/pages/AntropometriaListPage';
import CreateEntrevistaPage from '../../features/entrevista/pages/CreateEntrevistaPage';
import EntrevistaDetailPage from '../../features/entrevista/pages/EntrevistaDetailPage';
import EntrevistaListPage from '../../features/entrevista/pages/EntrevistaListPage';
import CreateCapacidadFuncionalPage from '../../features/capacidad_funcional/pages/CreateCapacidadFuncionalPage';
import CapacidadFuncionalDetailPage from '../../features/capacidad_funcional/pages/CapacidadFuncionalDetailPage';
import CapacidadFuncionalListPage from '../../features/capacidad_funcional/pages/CapacidadFuncionalListPage';
import CreateEncoderPage from '../../features/encoder/pages/CreateEncoderPage';
import EncoderDetailPage from '../../features/encoder/pages/EncoderDetailPage';
import EncoderListPage from '../../features/encoder/pages/EncoderListPage';
import CreatePacientePage from '../../features/pacientes/pages/CreatePacientePage';
import ExportPacientesExcelPage from '../../features/pacientes/pages/ExportPacientesExcelPage';
import PacientesHomePage from '../../features/pacientes/pages/PacientesHomePage';
import PacienteDetailPage from '../../features/pacientes/pages/PacienteDetailPage';
import UserProfilePage from '../../features/users/pages/UserProfilePage';
import CreateValoracionFuncionalPage from '../../features/valoracion_funcional/pages/CreateValoracionFuncionalPage';
import ValoracionFuncionalDetailPage from '../../features/valoracion_funcional/pages/ValoracionFuncionalDetailPage';
import ValoracionFuncionalListPage from '../../features/valoracion_funcional/pages/ValoracionFuncionalListPage';
import DashboardPage from '../../features/dashboard/pages/DashboardPage';

export const getUserRoutes = ({ selectedPaciente, setSelectedPaciente }) => [
  { path: '/dashboard', element: <DashboardPage /> },
  { path: '/home', element: <PacientesHomePage selectedPaciente={selectedPaciente} setSelectedPaciente={setSelectedPaciente} /> },
  { path: '/crear-paciente-user', element: <CreatePacientePage /> },
  { path: '/editar-paciente/:idPaciente', element: <CreatePacientePage /> },

  { path: '/crear-entrevista/:idPaciente', element: <CreateEntrevistaPage /> },
  { path: '/crear-sppb-tug/:idPaciente', element: <CreateCapacidadFuncionalPage /> },
  { path: '/crear-5sts-encoder/:idPaciente', element: <CreateEncoderPage /> },
  { path: '/crear-antropometria/:idPaciente', element: <CreateAntropometriaPage /> },
  { path: '/crear-fuerza-presion/:idPaciente', element: <CreateValoracionFuncionalPage /> },

  { path: '/crear-sp/:idPaciente', element: <CuestionarioIncontinencia /> },
  { path: '/crear-vent/:idPaciente', element: <CuestionarioVent /> },
  { path: '/crear-tesis/:idPaciente', element: <CuestionarioTesisTorres /> },
  { path: '/editar-sp/:idPaciente/:idCuestionario', element: <CuestionarioIncontinencia /> },
  { path: '/editar-vent/:idPaciente/:idCuestionario', element: <CuestionarioVent /> },
  { path: '/editar-tesis/:idPaciente/:idCuestionario', element: <CuestionarioTesisTorres /> },
  { path: '/crear-cuestionarios/:idPaciente', element: <Otros /> },
  { path: '/crear-otros/:idPaciente', element: <Otros /> },

  { path: '/ver-valoracion-funcional/:idTipo/:paciente', element: <ValoracionFuncionalDetailPage /> },
  { path: '/ver-capacidad-funcional/:idTipo/:paciente', element: <CapacidadFuncionalDetailPage /> },
  { path: '/ver-antropometria/:medidaId/:pacienteId', element: <AntropometriaDetailPage /> },
  { path: '/ver-encoder/:encoderId/:pacienteId', element: <EncoderDetailPage /> },
  { path: '/ver-entrevista/:idEntrevista/:paciente', element: <EntrevistaDetailPage /> },
  { path: '/ver-sp/:idCuestionario/:paciente', element: <MainCuestionarioSP /> },
  { path: '/ver-vent/:idCuestionario/:paciente', element: <MainCuestionarioVent /> },
  { path: '/ver-tesis/:idCuestionario/:paciente', element: <MainCuestionarioTesisTorres /> },
  { path: '/ver-cuestionarios/:idTipo/:paciente', element: <MainOtros /> },
  { path: '/ver-Otros/:idTipo/:paciente', element: <MainOtros /> },
  { path: '/ver-otros/:idTipo/:paciente', element: <MainOtros /> },
  { path: '/ver-usuario', element: <UserProfilePage /> },

  { path: '/paciente/:idPaciente', element: <PacienteDetailPage /> },
  { path: '/exportar-pacientes-excel', element: <ExportPacientesExcelPage /> },

  { path: '/lista-entrevistas', element: <EntrevistaListPage /> },
  { path: '/lista-antropometria', element: <AntropometriaListPage /> },
  { path: '/lista-capacidad-funcional', element: <CapacidadFuncionalListPage /> },
  { path: '/lista-valoracion-funcional', element: <ValoracionFuncionalListPage /> },
  { path: '/lista-cuestionarios', element: <ListOtros /> },
  { path: '/lista-otros', element: <ListOtros /> },
  { path: '/lista-vent', element: <ListCuestionarioVent /> },
  { path: '/lista-sp', element: <ListCuestionarioSP /> },
  { path: '/lista-tesis', element: <ListCuestionarioTesisTorres /> },
  { path: '/lista-encoder', element: <EncoderListPage /> },
];
